import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/config";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const exchange = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/login", { replace: true });
        return;
      }
      const session_id = decodeURIComponent(match[1]);
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        // Strip hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.name}.`);
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (err) {
        const msg = formatApiError(err?.response?.data?.detail) || "Google sign-in failed";
        setError(msg);
        toast.error(msg);
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    };
    exchange();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] text-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-14 h-14 rounded-full border-2 border-[#FF8A00]/30 border-t-[#FF8A00] animate-spin mx-auto" />
        <p className="text-white/60 mt-6 text-sm">{error || "Completing sign in…"}</p>
      </div>
    </div>
  );
}
